// extracted by mini-css-extract-plugin
module.exports = {"notify":"notify-add_notify__kX9kh","notify_msg":"notify-add_notify_msg__skQJk","notify_cancelBtn":"notify-add_notify_cancelBtn__ra_RC"};